var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCortexLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 728.3 165.9",
    style: {
      enableBackground: "new 0 0 728.3 165.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#8B8B8B;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M266.9,163.9c0-26.8-1.9-53,0.5-78.9c3-32.2,27.8-51.6,64.4-54.1c5.4-0.4,10.9,0,16.8,0v20.3 c-8.9,1.7-17.8,3-26.6,5.1c-21.3,5.2-30.6,15.9-31.8,37.7c-1,19.6-1.2,39.2-1.8,58.8c-0.1,3.5,0,7,0,11.1L266.9,163.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M520.8,145.5h66.5c0.5,0,1,0.4,1,1v17.1c0,1.4,0,1.4-3,1.4c-33.2-0.8-66.6,0.9-99.4-3.3 c-29.8-3.9-50.2-35.4-48.4-65.9c1.9-32.6,25.8-59.1,56.6-63.3c25.1-3.4,46.5,3.2,63.7,22c9.6,10.6,10.2,18.1,2.4,29.9 c-12.8,19.3-25.9,38.5-40.2,59.7C519.6,144.6,520,145.5,520.8,145.5z M460.5,103.7c-0.5,11.6,7.1,24,20.7,33.5 c6.6,4.6,10.7,4.7,15.6-2.8c12.7-19.4,25.9-38.4,39.6-57.2c4.4-6,3.3-9.5-1.7-13.8c-14-12.2-29.9-14.8-46.5-7.7 C469.8,63.5,461.1,78.6,460.5,103.7L460.5,103.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M598.1,33.2c14.7-6,27.2-2.4,37.8,10.6c8.6,10.6,16.8,21.5,26,33.3c9.3-12.1,17.8-23.2,26.4-34.2 c9.6-12.2,21-15.4,37.4-10c-11.8,15.2-23.3,30-34.8,44.9c-14.1,18.3-14.1,18.3,0,36.4c10.6,13.7,21.4,27.3,32,40.9 c1.9,2.5,3.6,5.2,5.5,8c-16.5,5.9-29,1.9-38.5-11.2c-8-11.1-16.5-21.9-24.9-32.7c0,0-1.9-1.7-4-3.5c-9,12-17.8,23.6-26.5,35.3 c-10.2,13.9-22.2,17.9-39.7,12.1c13.1-17,25.9-33.7,38.9-50.2s13.2-16.6,0.3-33.3C622,64.3,610.1,48.9,598.1,33.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M378.2,0v29.4l21.2,1.9v20.3l-18.2,1.3c0,19.9-1.6,39.5,0.5,58.7c1.8,16.3,18.1,28.7,35.1,31 c6.4,0.9,12.9,1.7,20,2.6v18c-41.7,9.2-80.1-20.1-81.3-62.6c-0.9-30.7-0.1-61.5-0.5-92.2c-0.1-6,2.1-8.4,7.9-8.3 C367.8,0.1,372.6,0,378.2,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M192.5,31.7c36.8,0.1,68.3,31,68.1,67c-0.2,36.6-30.9,66.7-68,66.9s-67.9-30.1-68-66.8 C124.6,62.4,155.7,31.7,192.5,31.7z M148,98.7c-0.1,25,20.2,45.6,44.8,45.3c24.9-0.3,44.7-20.7,44.4-45.6c0,0,0-0.1,0-0.1 c-0.1-24.7-20.2-45-44.3-44.8c-24.9,0-45,20.2-44.9,45.1C148,98.7,148,98.7,148,98.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M118.4,140.5c-20.8,29.2-65.3,33.2-95,8.8c-29-23.9-31.4-68.2-5.2-96C46,23.8,90.9,25.1,118.7,56 c-9.9,12-13.2,12.8-26.8,5.8C63.9,47.8,40,54,28.1,78.4c-8.4,17-5.4,37.5,7.6,51.3c12.8,13.8,29.9,17.1,48.8,9.4 c1.8-0.7,3.9-1.2,5.2-2.5C100.4,127.2,109.8,129.5,118.4,140.5z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCortexLogo);
export default __webpack_public_path__ + "static/media/cortexLogo.612995ecbaaa7141383b628697c00df1.svg";
export { ForwardRef as ReactComponent };